import { Button, Space } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { COLORS } from "../../../constants";
import ManagementPageContainer from "../../components/ManagementPageContainer/ManagementPageContainer";

const ManageAccountPageUser = () => {
  return (
    <ManagementPageContainer title={"User Accounts"}>
      <Space size={"middle"} direction={"vertical"} style={{ width: "100%" }}>
        <Link to={"/v2/Administrator/accounts/user/create"}>
          <Button block type="primary">
            CREATE USER ACCOUNT
          </Button>
        </Link>
        <Link to={"/v2/Administrator/accounts/user/view"}>
          <Button
            style={{
              backgroundColor: COLORS.orange,
              borderColor: COLORS.orange,
            }}
            block
            type="primary"
          >
            VIEW USER ACCOUNT
          </Button>
        </Link>
      </Space>
    </ManagementPageContainer>
  );
};

export default ManageAccountPageUser;
